export default class UserSearch {
	id = null
	keywords = []
}